// P4 — data-driven level progression (Document 11 §P4). Deliberately not
// hard-coded into any UI component: LevelBadge/Dashboard/Profile all call
// getLevelForXP() and render whatever it returns, so adding Level 7 later
// is a one-line change here, not a UI rewrite.
export interface LevelDefinition {
  level: number
  name: string
  minXP: number
}

export const LEVELS: LevelDefinition[] = [
  { level: 1, name: 'Cyber Rookie', minXP: 0 },
  { level: 2, name: 'Cyber Learner', minXP: 150 },
  { level: 3, name: 'Cyber Defender', minXP: 400 },
  { level: 4, name: 'Cyber Guardian', minXP: 800 },
  { level: 5, name: 'Cyber Champion', minXP: 1400 },
  { level: 6, name: 'Cyber Master', minXP: 2200 },
]

export interface LevelProgress {
  level: number
  name: string
  currentXP: number
  xpIntoLevel: number
  xpForNextLevel: number | null // null at the max level — nothing further to grind toward
  progressPercent: number // 0-100 toward the next level; 100 if at max level
  nextLevelName: string | null
}

export function getLevelForXP(xp: number): LevelProgress {
  const sorted = [...LEVELS].sort((a, b) => a.minXP - b.minXP)
  let current = sorted[0]
  for (const def of sorted) {
    if (xp >= def.minXP) current = def
    else break
  }
  const currentIndex = sorted.findIndex((d) => d.level === current.level)
  const next = sorted[currentIndex + 1] ?? null

  const xpIntoLevel = xp - current.minXP
  const xpForNextLevel = next ? next.minXP - current.minXP : null
  const progressPercent = next ? Math.min(100, Math.round((xpIntoLevel / xpForNextLevel!) * 100)) : 100

  return {
    level: current.level,
    name: current.name,
    currentXP: xp,
    xpIntoLevel,
    xpForNextLevel,
    progressPercent,
    nextLevelName: next?.name ?? null,
  }
}
